export default __webpack_public_path__ + "static/media/evm-logo.93e91438.svg";